import { useEffect } from 'react';

const getPublishedTime = (image) => new Date(image.published || 0).getTime();

const toNavigationImage = (image) => ({
    id: String(image.id),
    title: image.title,
    url_regular: image.url_regular,
    url_hd: image.url_hd,
    url_regular_fallback: image.url_regular_fallback,
    url_hd_fallback: image.url_hd_fallback,
    video_file: image.video_file,
    encoded_video_file: image.encoded_video_file,
    loop_video: image.loop_video
});

const useImageDetailData = ({
    apiUrl,
    imageId,
    navigationImages,
    setImage,
    setNavigationImages
}) => {
    useEffect(() => {
        const hydrateImageFromApi = async () => {
            if (!imageId) {
                return;
            }

            try {
                const res = await fetch(`${apiUrl}/api/getImages`);
                const data = await res.json();
                const matchedImage = (data || []).find(
                    (img) => String(img.id) === String(imageId)
                );

                if (!matchedImage) {
                    return;
                }

                if (!navigationImages || navigationImages.length === 0) {
                    const sortedImages = [...(data || [])]
                        .sort((a, b) => getPublishedTime(b) - getPublishedTime(a))
                        .map(toNavigationImage);

                    setNavigationImages(sortedImages);
                }

                setImage((prev) => {
                    if (!prev) {
                        return matchedImage;
                    }

                    // The API is authoritative: spreading `prev` last would let a
                    // stale cached URL win over a corrected one from the server,
                    // and the correction could never reach a warm session.
                    return {
                        ...prev,
                        ...matchedImage,
                        url_regular: matchedImage.url_regular || prev.url_regular,
                        url_hd: matchedImage.url_hd || prev.url_hd,
                        description: matchedImage.description || prev.description,
                        published: matchedImage.published || prev.published
                    };
                });
            } catch (err) {
                console.error('Failed to hydrate image from API:', err);
            }
        };

        hydrateImageFromApi();
    }, [apiUrl, imageId, navigationImages, setImage, setNavigationImages]);
};

export default useImageDetailData;
